// appointment-details-dialog.component.ts
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TicketModel } from '../invoice/tickets/ticket.model';
import { ContactModel } from '../contact/contact/contact.model';
import { UserCompanyModel } from '../user/usercompany/usercompany.model';
import { AccountModel } from '../invoice/tickets/account.model';
import { ConceptService } from '../concept/concept/concept.service';
import { ConceptModel } from '../concept/concept/concept.model';
import { AgendaProService } from './agendapro.service';
import { TicketAppointmentWrapperComponent } from './ticket-appointment-wrapper.component';

@Component({
    selector: 'app-appointment-details-dialog',
    templateUrl: './appointment-details-dialog.component.html',
    styleUrls: ['./agendapro.component.css'],
    standalone: false
})
export class AppointmentDetailsDialogComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<AppointmentDetailsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private conceptService: ConceptService,
        private agendaProService: AgendaProService,
        public dialog: MatDialog,
    ) { }

    ticket: TicketModel = new TicketModel();
    contactSelected: ContactModel;

    contactList = this.data.contacts;
    concepts = this.data.concepts;
    employees = this.data.employees;
    employeeName = '';
    clientName = '';

    userCompany: UserCompanyModel;
    entranceList: AccountModel[] = [];
    concept: ConceptModel;

    working = false;

    ngOnInit() {
        this.working = true;
        this.employeeName = this.employees.find(e => e.uid === this.data.appointment.employeeId).name;
        this.clientName = this.contactList.find(e => e.uid === this.data.appointment.contactUid).companyName;
        if (this.data.appointment.conceptUid == '00000000-0000-0000-0000-000000000000') {
            this.concept = new ConceptModel();
            this.concept.name = "Servicio";
            this.working = false;
        } else {
            this.conceptService.loadData(this.data.appointment.conceptUid).then(response => {
                this.concept = response;
                this.working = false;
            });
        }
    }

    createTicket() {
        this.dialog.open(TicketAppointmentWrapperComponent, {
            data: {
                newEvent: this.data.appointment,
                contacts: this.data.contacts
            }
        });
        this.dialogRef.close();

    }

    delete() {
        this.agendaProService.deleteAppointment(this.data.appointment.id).then(result => this.dialogRef.close());
    }
}
